const Bookmark = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M7.00781 21.0674C6.71484 21.0674 6.48633 20.9736 6.32227 20.7861C6.1582 20.5986 6.07617 20.335 6.07617 19.9951V4.7373C6.07617 3.89941 6.28418 3.26953 6.7002 2.84766C7.11621 2.42578 7.7373 2.21484 8.56348 2.21484H15.4365C16.2627 2.21484 16.8838 2.42578 17.2998 2.84766C17.7158 3.26953 17.9238 3.89941 17.9238 4.7373V19.9951C17.9238 20.335 17.8418 20.5986 17.6777 20.7861C17.5137 20.9736 17.2852 21.0674 16.9922 21.0674C16.7754 21.0674 16.5732 20.9941 16.3857 20.8477C16.2041 20.7012 15.9141 20.4375 15.5156 20.0566L12.0791 16.6729C12.0264 16.6143 11.9736 16.6143 11.9209 16.6729L8.48438 20.0566C8.08594 20.4434 7.79297 20.707 7.60547 20.8477C7.41797 20.9941 7.21875 21.0674 7.00781 21.0674Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default Bookmark;
